import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleShape = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 9,
	viewBox: "0 0 17 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.5146 8.02942L8.51465 0.0294189L0.514648 8.02942H16.5146Z",
		fill: "white"
	})
});
export default SvgTriangleShape;
